module.exports = __webpack_public_path__ + "img/company1.9b87c401.png";